import React, { useState, useEffect } from "react";
import "./PipelinesPage.css";
import {
  Table,
  Pagination,
  Input,
  InputGroup,
  Rate,
  Tabs,
  Placeholder,
  Whisper,
  IconButton,
} from "rsuite";
import SearchIcon from "@rsuite/icons/Search";
import SessionExpiredModal from "../SessionExpiredModal/SessionExpiredModal";
import mapleLoading from "../../assets/images/maple-logo-loading.gif";
import * as util from "../../util/PipelinesPageUtil/PipelinesPageUtil";
import PlusIcon from "@rsuite/icons/Plus";
import ReloadIcon from "@rsuite/icons/Reload";
import FunnelIcon from "@rsuite/icons/Funnel";

const { Column, HeaderCell, Cell } = Table;
const rowKey = "id";

const PipelinesPage = () => {
  const [limit, setLimit] = React.useState(30);
  const [page, setPage] = React.useState(1);
  const [sortColumn, setSortColumn] = React.useState();
  const [sortType, setSortType] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [pipelines, setPipelines] = useState([]);
  const [filterDatasource, setFilterDatasource] = useState([]);
  const [selectedDatasources, setSelectedDatasources] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = React.useState([]);

  useEffect(() => {
    util.fetchData(
      setPipelines,
      setTimeout,
      setLoading,
      setShowTable,
      setShowModal
    );
  }, []);


  return (
    <div className="container" data-testid="pipelines-page">
      <div className="main-container">
        <div className="title-container">Pipelines</div>
        <hr className="header-line" />
        <div className="utility-wrap-container">
          <div className="search-bar">
            <InputGroup>
              <Input
                size="md"
                value={searchQuery}
                onChange={(value) => setSearchQuery(value)}
                role="search-box"
              />
              <InputGroup.Addon>
                <SearchIcon />
              </InputGroup.Addon>
            </InputGroup>
          </div>
          <div>
            <IconButton icon={<PlusIcon />} disabled className="new-button">
              Add
            </IconButton>
          </div>

          <div>
            <IconButton
              icon={<ReloadIcon />}
              className="refresh-button"
              onClick={() =>
                util.handleRefresh(setPipelines, setLoading, setShowModal)
              }
              size="sm"
              aria-label="refresh"
            />
          </div>
        </div>
      </div>
      {!showTable ? (
        <div className="loading-container">
          <img
            src={mapleLoading}
            alt="Loading Animation"
            className="loading-gif"
          />
        </div>
      ) : null}
      {showTable ? (
        <div className="pipelines-tabs-container">
          <Tabs defaultActiveKey="1">
            <Tabs.Tab eventKey="1" title="All Pipelines">
              <div></div>
              <div className="table-container">
                <Table
                  fillHeight
                  data={util.getData(
                    limit,
                    page,
                    pipelines,
                    searchQuery,
                    filterDatasource
                  )}
                  sortColumn={sortColumn}
                  sortType={sortType}
                  onSortColumn={(sortColumn, sortType) =>
                    util.handleSortColumn(
                      sortColumn,
                      sortType,
                      pipelines,
                      setPipelines,
                      setSortColumn,
                      setSortType,
                      setLoading
                    )
                  }
                  loading={loading}
                  onRowClick={(rowData) =>
                    util.handleExpanded(
                      rowData,
                      rowKey,
                      expandedRowKeys,
                      setExpandedRowKeys
                    )
                  }
                  bordered
                  color="yellow"
                  hover
                  rowHeight={30}
                  rowKey={rowKey}
                  expandedRowKeys={expandedRowKeys}
                  renderRowExpanded={util.renderRowExpanded}
                  rowExpandedHeight={40}
                  shouldUpdateScroll={false}
                >
                  <Column width={300} align="left" sortable resizable>
                    <HeaderCell data-testid="name-header">Name</HeaderCell>
                    <Cell dataKey="name" />
                  </Column>
                  <Column width={150} align="left" resizable>
                    <HeaderCell background-color="red">
                      Datasource
                      <Whisper
                        trigger="click"
                        placement="bottom"
                        speaker={(props, ref) =>
                          util.renderOverlay(
                            props,
                            ref,
                            pipelines,
                            selectedDatasources,
                            setSelectedDatasources,
                            setFilterDatasource
                          )
                        }
                      >
                        <IconButton
                          icon={<FunnelIcon />}
                          className="filter-button"
                        />
                      </Whisper>
                    </HeaderCell>
                    <Cell dataKey="datasource" />
                  </Column>
                  <Column
                    width={200}
                    align="center"
                    verticalAlign="center"
                    sortable
                    resizable
                  >
                    <HeaderCell>Status</HeaderCell>
                    <util.StatusCell dataKey={"status"} />
                  </Column>
                  <Column width={250} align="center" resizable>
                    <HeaderCell>Description</HeaderCell>
                    <Cell dataKey="description" />
                  </Column>
                  <Column
                    width={150}
                    align="center"
                    verticalAlign="center"
                    resizable
                  >
                    <HeaderCell>Data</HeaderCell>
                    <util.DataCell />
                  </Column>
                  <Column width={150} align="left" sortable resizable>
                    <HeaderCell>Created At</HeaderCell>
                    <Cell>
                      {(rowData) => (
                        <span>{util.formatDate(rowData.creationTime)}</span>
                      )}
                    </Cell>
                  </Column>
                  <Column width={200} align="center" sortable resizable>
                    <HeaderCell>Created By</HeaderCell>
                    <Cell dataKey="createdBy" />
                  </Column>
                  <Column
                    width={200}
                    align="center"
                    verticalAlign="center"
                    resizable
                  >
                    <HeaderCell>Dashboard</HeaderCell>
                    <util.DashboardCell />
                  </Column>
                  <Column width={250} align="center">
                    <HeaderCell>Favorite</HeaderCell>
                    <Cell style={{ padding: "6px" }}>
                      <Rate max={1} color="yellow" size="xs" />
                    </Cell>
                  </Column>
                </Table>
              </div>
            </Tabs.Tab>
            <Tabs.Tab eventKey="2" title="Favourites" disabled>
              <Placeholder.Paragraph graph="square" />
            </Tabs.Tab>
          </Tabs>
        </div>
      ) : null}
      <div style={{ padding: 8 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={
            util.getFilteredData(pipelines, searchQuery, filterDatasource)
              .length
          }

          limitOptions={[10, 30, 50]}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={(dataKey) =>
            util.handleChangeLimit(dataKey, setPage, setLimit)
          }
        />
      </div>
      <SessionExpiredModal
        open={showModal}
        onHide={() => setShowModal(false)}
      />
    </div>
  );
};

export default PipelinesPage;
